//产品管理上传文件
import service from "@/utils/axios";

// /appVersion开头 + /getPageInfo 就是获取分页数据
// 获取分页数据
export const getPageInfo = (params) => service.post('/base/appVersion/getPageInfo',  params ,{
  headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});

// 版本号检查
export const checkVersion = (params) => service.get('/base/appVersion/checkVersion', { params });

// 获取最新版本信息
export const getVersionInfo = (params) => service.post('/base/appVersion/getVersionInfo',  params ,{
  headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});

// 添加版本信息
export const addAppVersion = (params) => service.post('/base/appVersion/addAppVersion',  params ,{
  headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});

// 删除版本
export const deleteAppVersion = (params) => service.delete(`/base/appVersion/deleteAppVersion/${params.id}`,  params ,{
  headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});
